export default __webpack_public_path__ + "static/media/UGC.86f64f46.png";